import React, {useState} from "react"
import _ from "lodash"
import { Button, Dropdown, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types"
import { permanentColumns } from "../../../utils/constants";
import "./OrderColumns.css"
const OrderColumns =
({
    currentLayout,
    savedLayouts,
    allColumns,
    onLayoutSelected,
    setShowOverwriteLayoutConfirm,
    tableInstance,
    setColumnsConfig,
    setShowDeleteLayoutConfirm,
    setShowSetDefaultLayoutConfirm,
    setShowShareLayoutConfirm,
    currentUserId,
    onColumnToggle,
    setShowNewLayoutModal,
    editingLayout,
})=>{
    const { t } = useTranslation()
    const currentLayoutName = _.isEmpty(currentLayout.translationKey)
                                            ? currentLayout.name
                                            : t(currentLayout.translationKey);
    const shouldDisableDeleteButton = () => (!currentLayout.isDeletable);
    const [ selectAll, setSelectAll ] = useState(false)
    const renderItem = (layout) => {
        const isOwn = layout.userId === currentUserId;
        const isCurrent = currentLayout.name === layout.name;

        return(
            <div className="saved-layout-data">
                <span className={!isOwn ? "layout-shared-name" : ""}>{layout.name}</span>
                {isOwn && layout.isShared && (
                    <span className={`layout-shared-badge${isCurrent ? "" : " layout-shared-badge--right"}`}>{t("ordersTable.layouts.sharedBadge")}</span>
                )}
                <div>
                    {isCurrent && isOwn && (
                        <div>
                            <Icon name="star"
                                onClick={(e) => { e.stopPropagation(); setShowSetDefaultLayoutConfirm(true); }}
                                className={layout.isDefault ? "layout-default-icon" : "layout-write-icon"}/>
                            <Icon name="share"
                                onClick={(e) => { e.stopPropagation(); setShowShareLayoutConfirm(true); }}
                                className={layout.isShared ? "layout-default-icon" : "layout-write-icon"}/>
                            <Icon name="write"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setShowOverwriteLayoutConfirm(true);
                                    setColumnsConfig(tableInstance.state);
                                }}
                                className="layout-write-icon"/>
                            <Icon name="trash"
                                disabled={shouldDisableDeleteButton()}
                                onClick={(e) => { e.stopPropagation(); setShowDeleteLayoutConfirm(true); }}
                                className="layout-trash-icon"/>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    return(
        <Button.Group>
            <Dropdown
                icon={"align left"}
                text={currentLayoutName}
                floating
                labeled
                button
                // Button-content from suggested order filter css 
                className="icon suggested-order-filter button-content"
                scrolling
            >
                <Dropdown.Menu>
                <Dropdown.Header>{t("ordersTable.saved")}</Dropdown.Header>
                <Dropdown.Divider/>
                {savedLayouts
                    .filter((layout) => !_.isEmpty(layout.translationKey) || layout.userId === currentUserId)
                    .map((layout) => (
                        <Dropdown.Item
                            key={layout.id}
                            onClick={() => onLayoutSelected(layout.id)}>
                            {_.isEmpty(layout.translationKey) ? renderItem(layout) : t(layout.translationKey)}
                        </Dropdown.Item>
                    ))}
                {savedLayouts.some((layout) => _.isEmpty(layout.translationKey) && layout.userId !== currentUserId) && (
                    <>
                        <Dropdown.Divider/>
                        <Dropdown.Header>{t("ordersTable.sharedLayouts")}</Dropdown.Header>
                        <Dropdown.Divider/>
                        {savedLayouts
                            .filter((layout) => _.isEmpty(layout.translationKey) && layout.userId !== currentUserId)
                            .map((layout) => (
                                <Dropdown.Item
                                    key={layout.id}
                                    onClick={() => onLayoutSelected(layout.id)}>
                                    {renderItem(layout)}
                                </Dropdown.Item>
                            ))}
                    </>
                )}
                <Dropdown.Divider/>
                <Dropdown.Header>{t("ordersTable.columnsName")}</Dropdown.Header>
                <Dropdown.Divider/>

                <Dropdown.Item onClick={(e)=>e.stopPropagation()}>
                    <div className="ui checkbox">
                        <input
                            type="checkbox"
                            onClick={() => allColumns.forEach((column) => {
                                if(!_.includes(permanentColumns, column.id)){
                                    column.toggleHidden(selectAll)
                                }
                                setSelectAll(!selectAll)
                            }
                            )}
                            checked={selectAll}
                        />{" "}
                        <label>{t("ordersTable.columns.all")}</label>
                    </div>
                </Dropdown.Item>
                {allColumns.map(column => {
                    return (
                    <Dropdown.Item key={column.id} onClick={(e)=>e.stopPropagation()}>
                        <div className="ui checkbox">
                        <input
                            disabled={_.includes(permanentColumns, column.id)}
                            type="checkbox"
                            onClick={() => {
                                onColumnToggle(column.id)
                                setSelectAll(false)
                            }}
                            {...column.getToggleHiddenProps()}
                        />{" "}
                        <label>{column.Header}</label>
                        </div>
                    </Dropdown.Item>
                    );
                })}
                </Dropdown.Menu>
            </Dropdown>
            {
                editingLayout && <Button icon="save" className="order-column-button" onClick={()=>setShowNewLayoutModal(true)}/>
            }
        </Button.Group>
    )
}

OrderColumns.propTypes = {
    currentLayout: PropTypes.object,
    savedLayouts: PropTypes.array,
    allColumns: PropTypes.array,
    onLayoutSelected: PropTypes.func,
    setShowOverwriteLayoutConfirm: PropTypes.func,
    tableInstance: PropTypes.object,
    setColumnsConfig: PropTypes.func,
    setShowDeleteLayoutConfirm: PropTypes.func,
    setShowSetDefaultLayoutConfirm: PropTypes.func,
    setShowShareLayoutConfirm: PropTypes.func,
    currentUserId: PropTypes.number,
    onColumnToggle: PropTypes.func,
    setShowNewLayoutModal: PropTypes.func,
    editingLayout: PropTypes.bool,
}

export default OrderColumns